import axios from "axios";
import { formatError, logError } from "./logging";
import { toast } from "react-toastify";
import { API_URL } from "../config/api";
const API_BASE_URL = `${API_URL}/api/prompts`; 

// Fetch all prompts
export const fetchPrompts = async () => {
  try {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
    const response = await axios.get(`${API_BASE_URL}?timezone=${userTimezone}`);
    
    if (response.status !== 200) {
      logError(response.data)
      toast.error(response.data.message || "Failed to fetch prompts.")
      return null
    }
    
    return response.data;
  } catch (error) {
    const errorData = error.response?.data || formatError(error)
    logError(errorData)
    toast.error(errorData.message || "An error occurred while fetching the prompts. Please try again.")
    return null
  }
};

// Fetch a prompt by ID
export const fetchPromptById = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/${id}`);
    
    if (response.status !== 200) {
      logError(response.data)
      toast.error(response.data.message || "Failed to fetch prompt.")
      return null
    }
    
    return response.data;
  } catch (error) {
    const errorData = error.response?.data || formatError(error)
    logError(errorData)
    toast.error(errorData.message || "An error occurred while fetching the prompt. Please try again.")
    return null
  }
};

// Create a new prompt
export const createPrompt = async (data) => {
  try {
    const response = await axios.post(API_BASE_URL, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error creating the prompt.";
  }
};

// Update an existing prompt
export const updatePrompt = async (id, data) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/${id}`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating the prompt.";
  }
};

// Delete a prompt
export const deletePrompt = async (id) => {
  try {
    await axios.delete(`${API_BASE_URL}/${id}`);
  } catch (error) {
    throw error.response?.data || "Error deleting the prompt.";
  }
};

